module.exports = __webpack_public_path__ + "static/media/react.37fe8322.png";